






























import { Component, Vue, Prop } from 'vue-property-decorator';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({name: 'c-checkup-modal'})
export default class CBudgetCheckupModal extends Vue {
    private showModal = false;
    private dataLst: any [] = [];

    private showEvent(dataLst: any) {
        if (!dataLst || !dataLst.length) { return; }
        this.dataLst = dataLst;
        this.showModal = true;
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            title: this.getBudgetText('budget-event.checkup-title') // Сумма, распределенная по ГУ, превышает сумму, подтвержденную УО по следующим мероприятиям:
        }
        return obj;
    }

    private okClk() {
        this.showModal = false;
        this.dataLst = [];
    }
}
